export const isExternalLink = (link) =>
	link?.startsWith("http://") || link?.startsWith("https://");

export const isEvenNumber = (number) => number % 2 === 0;
